<template>
  <div class="row gx-0 mb-30">
    <div class="col-md-6">
      <div class="filter-left d-flex align-items-center flex-wrap">
        <button
          type="button"
          class="btn style-two"
          data-bs-toggle="modal"
          data-bs-target="#filterModal"
        >
          Filter <img src="../../assets/img/icons/filter.svg" alt="Image" />
        </button>
        <form @submit.prevent="handleSearch" class="search-area position-relative w-sm-100">
          <input
            v-model="searchTerm"
            type="text"
            placeholder="Search On This Table"
            class="w-100 h-55 bg_ash border-0 rounded-1 fs-14 text-black bg-white"
          />
          <button
            type="submit"
            class="bg-transparent border-0 position-absolute top-0 end-0 h-100 pt-0 py-0 px-2"
          >
            <img src="../../assets/img/icons/search.svg" alt="Image" />
          </button>
        </form>
      </div>
    </div>
    <div class="col-md-6">
      <div
        class="filter-right d-flex align-items-center justify-content-md-end flex-wrap"
      >
        <a href="javascript:void(0)" @click="handleExcelExport" class="btn style-three"> Excel </a>
        <div class="btn style-five upload-btn">
          Import
          <img src="../../assets/img/icons/download.svg" alt="Image" />
          <input type="file" name="myfile" />
        </div>
        <router-link :to="btnLink" class="btn style-one">
          Create {{ btnText }}
          <img src="../../assets/img/icons/add-circle.svg" alt="Image" />
        </router-link>
      </div>
    </div>
  </div>

  <FilterModal @filter="handleFilter" />
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import FilterModal from "./FilterModal.vue";
import { API_BASE_URL } from "../../services/api";

export default defineComponent({
  name: "FilterContent",
  props: ["btnText", "btnLink"],
  emits: ["filter"],
  components: {
    FilterModal,
  },
  setup(_, { emit }) {
    const searchTerm = ref("");
    const activeFilters = ref<any>({});

    const handleFilter = (filters: any) => {
      activeFilters.value = filters;
      emit("filter", { ...filters, q: searchTerm.value });
    };

    const handleSearch = () => {
      emit("filter", { ...activeFilters.value, q: searchTerm.value });
    };

    const handleExcelExport = () => {
      const params = new URLSearchParams();
      
      if (searchTerm.value) params.append("q", searchTerm.value);
      if (activeFilters.value.customer_id) params.append("customer_id", activeFilters.value.customer_id);
      if (activeFilters.value.warehouse_id) params.append("warehouse_id", activeFilters.value.warehouse_id);
      if (activeFilters.value.status) params.append("status", activeFilters.value.status);
      
      const token = localStorage.getItem("token");
      if (token) params.append("token", token);

      window.open(`${API_BASE_URL}/reports/sales/export?${params.toString()}`, "_blank");
    };

    return {
      searchTerm,
      handleFilter,
      handleSearch,
      handleExcelExport,
    };
  },
});
</script>

<style lang="scss" scoped>
.filter-left {
  button {
    margin-right: 10px;
  }
  .search-area {
    input {
      padding-left: 20px;
      &::placeholder {
        opacity: 0.8;
      }
    }
  }
}
.filter-right {
  a {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
  div,
  button {
    margin-right: 10px;
  }
}

@media only screen and (max-width: 767px) {
  .filter-left {
    .btn {
      margin-bottom: 15px;
    }
  }
  .filter-right {
    a,
    div,
    button {
      margin-bottom: 10px;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .filter-right {
    width: calc(100% + 20px);
    margin-left: -20px;
  }
}

@media only screen and (max-width: 991px) {
  .filter-left {
    margin-bottom: 20px;
  }
}

@media only screen and (min-width: 992px) {
  .filter-left {
    .search-area {
      width: 320px;
    }
  }
}

@media only screen and (min-width: 1400px) {
  .filter-left {
    button {
      margin-right: 15px;
    }
    .search-area {
      width: 320px;
    }
  }
  .filter-right {
    a,
    div,
    button {
      margin-right: 15px;
    }
  }
}
</style>
